import { styled } from '@mui/material';

import { RadioButtonSize } from '../types';

type StyledRadioButtonLabelProps = {
  size?: RadioButtonSize;
  disabled?: boolean;
};

export const StyledRadioButtonLabel = styled('label')<StyledRadioButtonLabelProps>`
  font-family: 'Roboto, sans-serif';
  font-weight: 400;
  letter-spacing: 0.15px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  cursor: pointer;
  color: ${({ disabled }) => (disabled ? '#d3d4d7' : '#333')};
  font-size: ${({ size }) =>
    size === RadioButtonSize.SMALL ? '12px' : size === RadioButtonSize.MEDIUM ? '14px' : '16px'};
  line-height: ${({ size }) =>
    size === RadioButtonSize.SMALL ? '12px' : size === RadioButtonSize.MEDIUM ? '143%' : '24px'};
  letter-spacing: ${({ size }) => (size === RadioButtonSize.MEDIUM ? '0.17px' : '0.15px')};
`;
